import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { postPages, showPages, updatePages } from "../../../MyApi/pages/index";
import { toast } from "react-toastify";

import i18next from "i18next";
import SkeletonWrapper from "../../../Components/UI/skeletonWrapper";

const AddPageModal = ({ show, onClose, refetch, modalMode, modalId }) => {  
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    is_active: 1,
  });
  console.log('AddPageModalComponentMount'  ,modalMode ,modalId)
  const [selectedLangCode, setSelectedLangCode] = useState("");

  const { data, isLoading } = useQuery(
    ["showPages", modalId, selectedLangCode],
    () => showPages(modalId, selectedLangCode),
    {
      enabled: modalMode === "edit" && !!modalId,
    },
  );
console.log('modalId', modalId)
  const page = data?.data?.page || {};
 console.log('data', data)
  useEffect(() => {
    if (modalMode === "edit" && page) {
      setFormData((prev) => ({
        ...prev,
        title: page.title,
        content: page.content,
        is_active: page.is_active ? 1 : 0,
      }));
    }
  }, [page.id]);

  useEffect(() => {
    if (modalMode === "edit") {
      const currentLang = i18next.language;
      setSelectedLangCode(currentLang);
    }
  }, []);

  const [validated, setValidated] = useState(false);

  const mutation = useMutation({
    mutationKey: ["postPages"],
    mutationFn: (postData) => postPages(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose("page", "add");
      refetch();
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "حدث خطأ ما";
      toast.error(message);
    },
  });

  const mutationUpdate = useMutation({
    mutationKey: ["updatePages", modalId],
    mutationFn: (postData) => updatePages(postData,  page.slug),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose("page", "edit");
      refetch();
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "حدث خطأ ما";
      toast.error(message);
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    // If form is invalid -> stop submission
    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    const sendFormData = new FormData();
    sendFormData.append("title", formData.title);
    sendFormData.append("content", formData.content);
    sendFormData.append("is_active", formData.is_active);


    if (modalMode === "edit") {
  sendFormData.append("_method", "PUT");
      sendFormData.append("lang", selectedLangCode);
      mutationUpdate.mutate(sendFormData);
    } else {
      mutation.mutate(sendFormData);
    }
  };

  return (
    <Modal show={show} onHide={() => onClose("page")} centered>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="add"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "edit" ? "تعديل" : "إضافة"} صفحة جديدة
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {modalMode === "edit" ? (
            <div>
              <label htmlFor="" className="form-label ">
                اللغة
              </label>
              <select
                className="form-control w-50"
                onChange={(e) => setSelectedLangCode(e.target.value)}
                value={selectedLangCode}
              >
                <option value="ar">العربية</option>
                <option value="en">English</option>
              </select>
            </div>
          ) : (
            <p className="text-muted small mb-3">أضف صفحة جديدة للنظام</p>
          )}

          <Form.Group className="mb-3">
            <Form.Label>عنوان الصفحة</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Form.Control
                type="text"
                name="title"
                placeholder="ادخل عنوان الصفحة"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              عنوان الصفحة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>محتوى الصفحة</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Form.Control
                as="textarea"
                rows={5}
                name="content"
                placeholder="ادخل محتوى الصفحة"
                value={formData.content}
                onChange={handleChange}
                required
              />
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              محتوى الصفحة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>الحالة</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Form.Select
                name="is_active"
                value={formData.is_active}
                onChange={handleChange}
                required
              >
                <option value="">اختر الحالة</option>
                <option value={1}>مفعل</option>
                <option value={0}>غير مفعل</option>
              </Form.Select>
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              الحالة مطلوبة
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="justify-content-start">
          <Button
            variant="primary"
            type="submit"
            disabled={mutation.isLoading || mutationUpdate.isLoading}
          >
            {mutation.isLoading || mutationUpdate.isLoading
              ? "جارٍ الإضافة..."
              : modalMode === "edit"
                ? "تعديل الصفحة"
                : "إضافة صفحة"}
          </Button>
          <button
            className="btn btn-white"
            type="button"
            onClick={() => onClose("page")}
          >
            إلغاء
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddPageModal;